import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * ErmesHotels
 */
const factory = function factory({ window, document, thn }) {
    let refreshPrice;
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.room, .rooms>div')) ?? [];
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray
            .map((room) => {
            const roomName = room.querySelector('H5, .room_name')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.rate, .rate-set'))
                ?.map((rate) => {
                const rateName = rate.querySelector('.name, rate-name>strong')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('.price-total, .price_from .number')?.textContent);
                const hasBreakfast = false;
                const isRefundable = !!rateName?.match(/flexible|flexibel/i);
                if (!rateName || !ratePrice) {
                    return null;
                }
                const rateData = {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
                return rateData;
            })
                .filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            const roomData = {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
            return roomData;
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        async languageCheck(ctx) {
            return new Promise((resolve, reject) => {
                const langDictionary = {
                    1: 'en',
                    2: 'it',
                    3: 'de',
                    4: 'fr',
                    5: 'es',
                    6: 'zh',
                    8: 'pt',
                };
                const urlLang = window.location.hash.match(/language\/(\d+)/)?.[1];
                const lang = urlLang ? langDictionary[urlLang] : undefined;
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        isUserLogged() {
            const isLogged = !document.querySelector('.ibe_login_btn');
            return isLogged;
        },
        generateSearchUrl(ctx) {
            // example url v1: https://book.dulacetduparc.com/#/hotel/1970/channel/569/language/2/rooms?arrival=20241227&departure=20241228&adults=2&childs=2&ages=2,1
            // example url v2: https://booking.parkhotelbrasilia.com/en/ecommerce/step?pf=ibe&checkin=2025-05-20&checkout=2025-05-21&rooms=1&promotion_code=special20&adults_0=2
            const url = new URL(ctx.baseUrl);
            const validUrlV1 = url.hash.includes('rooms');
            const validUrlV2 = url.pathname.includes('ecommerce/step');
            if (!validUrlV1 && !validUrlV2) {
                ctx.newUrl = '';
                return ctx;
            }
            // Version 1
            if (validUrlV1) {
                url.pathname = url.hash.split('?')?.[0];
                url.hash = '';
                url.searchParams.set('arrival', '[date_begin]');
                url.searchParams.set('departure', '[date_end]');
                url.searchParams.set('adults', '[adults]');
                url.searchParams.set('childs', '[children]');
                const childrenAges = ctx.data.roomsDispo?.[0]?.childrenAges;
                if (childrenAges) {
                    url.searchParams.set('ages', childrenAges.join(','));
                }
                ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '');
                ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '');
                ctx.newUrl = url.toString().replace(/%23/, '#');
            }
            else { // Version 2
                url.searchParams.set('checkin', '[date_begin]');
                url.searchParams.set('checkout', '[date_end]');
                url.searchParams.set('rooms', '1');
                url.searchParams.set('adults_0', '[adults]');
                const children = ctx.data?.roomsDispo?.[0]?.children ?? 0;
                if (children && children > 0) {
                    url.searchParams.set('children_0', '[children]');
                }
                ctx.newUrl = url.toString();
                ctx.newData.dateBegin = ctx.data.dateBegin?.replace(/\//g, '-');
                ctx.newData.dateEnd = ctx.data.dateEnd?.replace(/\//g, '-');
            }
            return ctx;
        },
        boot() {
            const container = document.documentElement;
            if (container) {
                const refreshPage = thn.debounce(() => {
                    thn.pageCheck();
                    thn.languageCheck().catch(() => { });
                }, 1000);
                thn.observeDom(container, refreshPage, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                });
                thn.shutdown(() => {
                    refreshPage.cancel();
                    thn.stopObserveDom(container, refreshPage);
                });
            }
        },
        priceObserveDom(ctx) {
            refreshPrice = thn.debounce(() => {
                ctx.widget.refresh().catch(() => { });
            }, 800);
            thn.bus.on('dataLayer:event.view_item_list', refreshPrice);
            thn.pageUnload(() => {
                if (refreshPrice) {
                    thn.bus.detach('dataLayer:event.view_item_list', refreshPrice);
                }
            });
        },
        priceParseData_v1() {
            // Guests, Adults & Children
            const roomNumber = thn.parseNumber(document.querySelectorAll('.erm-bar-item')?.[1]?.querySelectorAll('span')?.[2]?.innerText) ?? 1;
            let adults = 2;
            let children = 0;
            if (roomNumber > 1) {
                adults = thn.parseNumber(document.querySelector('.room-to-select')?.textContent?.match(/\d+/g)?.[1]) ?? 2;
                children = thn.parseNumber(document.querySelector('.room-to-select')?.textContent?.match(/\d+/g)?.[2]) ?? 0;
            }
            else {
                adults = thn.parseNumber(document.querySelectorAll('.erm-bar-item')?.[1]?.querySelectorAll('span:not(.erm-searchbar-guest-label)')[0].innerText) ?? 2;
                children = thn.parseNumber(document.querySelectorAll('.erm-bar-item')?.[1]?.querySelectorAll('span:not(.erm-searchbar-guest-label)')[2].innerText) ?? 0;
            }
            // Dates
            const dates = document.querySelectorAll('.erm-date-item span');
            let dateBegin;
            let dateEnd;
            if (!thn.empty(dates)) {
                dateBegin = translateDate(dates[0]?.textContent?.replace(/(\d{2})$/, (match) => `20${match}`) ?? '', thn.data.language);
                dateEnd = translateDate(dates[1]?.textContent?.replace(/(\d{2})$/, (match) => `20${match}`) ?? '', thn.data.language);
            }
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd) ?? 1;
            // Prices & Currency || No Rooms
            const pricesEls = Array.from(document.querySelectorAll('.price-total'));
            const prices = pricesEls
                .map((price) => thn.parseNumber(price?.textContent))
                .filter((value) => typeof value !== 'undefined');
            const currency = thn.parseCurrency(document.querySelector('.price-total')?.textContent);
            const noAvailability = document.querySelector('#nodispotitle');
            if (!thn.empty(prices) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    adults,
                    children,
                    price: Math.min(...prices) / nights,
                    currency,
                    roomDetails: roomDetailsParseData(adults, children),
                };
            }
            if (noAvailability) {
                return {
                    adults,
                    children,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        priceParseData_v2() {
            const urlParams = new URLSearchParams((document.querySelector('#share_search_url'))?.value || '');
            // Dates
            const dates = document.querySelectorAll('.dates .value') ?? [];
            const dateBeginUrl = urlParams.get('checkin')?.replace(/-/, '/');
            const dateEndUrl = urlParams.get('checkout')?.replace(/-/, '/');
            const dateBegin = (!thn.empty(dates) && dates[0].textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1')) || dateBeginUrl;
            const dateEnd = (!thn.empty(dates) && dates[1].textContent?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1')) || dateEndUrl;
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd) ?? 1;
            // Room dispo
            const rooms = Array.from(document.querySelectorAll('.box>.rate-group')) ?? [];
            const roomsDispo = rooms.map((room) => {
                const price = thn.parseNumber(room.querySelector('.price_from .number')?.textContent);
                const adults = thn.parseNumber(room.querySelector('.adult')?.textContent) ?? 2;
                const children = thn.parseNumber(room.querySelector('.child')?.textContent) ?? 0;
                return {
                    adults,
                    children,
                    price,
                };
            }).sort((a, b) => (a.price ?? 0) - (b.price ?? 0));
            // Prices & Currency || No Rooms
            const price = roomsDispo[0]?.price;
            const priceElement = document.querySelector('.price');
            const currencyContent = priceElement ? window.getComputedStyle(priceElement, '::after').getPropertyValue('content') : null;
            const currency = currencyContent ? thn.parseCurrency(currencyContent.replace(/"/g, '')) : 'EUR';
            const noAvailability = document.querySelector('.pf_no_results');
            if (price && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    adults: roomsDispo[0].adults,
                    children: roomsDispo[0].children,
                    price: price / nights,
                    currency,
                    roomDetails: roomDetailsParseData(roomsDispo[0].adults, roomsDispo[0].children),
                };
            }
            if (noAvailability) {
                return {
                    adults: roomsDispo[0].adults,
                    children: roomsDispo[0].children,
                    currency,
                    dateBegin,
                    dateEnd,
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            // Booking ID
            const bookingId = document.querySelector('.voucher-details .reservation-dates div:nth-child(2), .reservation_code')?.textContent?.split(':')?.[1]?.trim();
            if (!bookingId) {
                return {
                    set: false,
                };
            }
            // Price & Currency
            const priceEl = document.querySelector('.total>span, #total_amount .number');
            const totalPrice = thn.parseNumber(priceEl?.textContent);
            const priceElement = document.querySelector('.price');
            const currencyContent = priceElement ? window.getComputedStyle(priceElement, '::after').getPropertyValue('content') : null;
            const currency = thn.parseCurrency(currencyContent);
            return {
                bookingId,
                price: totalPrice,
                currency,
            };
        },
    };
};

export { factory };
